import {Redirect} from "react-router-dom";

const Work = () => <Redirect to="/work/guide"/>

export default Work